
import './analytics-statictics.tag'
import 'components/chart/chart.tag'
import moment from 'moment'
riot.tag2('analytics', '  <loader if="{loader}"></loader>\n  <div hide="{loader}">\n    <div class="row">\n      <div class="col-md-12">\n        <div class="well well-sm">\n          <div class="form-inline">\n            <div class="form-group">\n              <button class="btn btn-success" type="button" onclick="{reload}"><i class="fa fa-refresh"></i> Обновить</button>\n            </div>\n            <div class="form-group">\n              <label class="control-label">Выберите период</label>\n              <datetime-picker class="form-control" name="startDate" format="DD.MM.YYYY"></datetime-picker> —\n              <datetime-picker class="form-control" name="endDate" format="DD.MM.YYYY"></datetime-picker>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <analytics-statictics value="{value}"></analytics-statictics>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-md-12">\n        <ul class="nav nav-tabs">\n          <li class="{active: name == tab}" each="{tabs}"><a href="#" onclick="{tabClick}">{title}</a></li>\n        </ul>\n      </div>\n    </div>\n    <div class="row" if="{tab == &quot;funnel&quot;}">\n      <div class="col-md-6 col-md-offset-3">\n        <loader if="{tabLoader == &quot;funnel&quot;}"></loader>\n        <chart type="funnel" data="{createChartFunnelData(value.funnel)}" options="{chartFunnelOptions}"></chart>\n      </div>\n    </div>\n    <div class="row" if="{tab == &quot;statisticsOrders&quot;}">\n      <div class="col-md-12">\n        <loader if="{tabLoader == &quot;statisticsOrders&quot;}"></loader>\n        <chart type="bar" data="{createChartStatisticsData(value.statisticsOrders)}" options="{chartFunnelOptions}"></chart>\n      </div>\n    </div>\n    <div class="row" if="{tab == &quot;products&quot;}">\n      <div class="col-md-12">\n        <loader if="{tabLoader == &quot;products&quot;}"></loader>\n        <form class="form-inline text-right m-t-2 m-b-2">\n          <div class="input-group">\n            <input class="form-control" name="search" id="productSearch" type="text" placeholder="Поиск" oninput="{find}"><span class="input-group-btn">\n              <button class="btn btn-default" onclick="{find}" type="submit"><i class="fa fa-search"></i></button></span>\n          </div>\n        </form>\n        <catalog-static cols="{productsCols}" rows="{value.products}" remove-toolbar="1" search="true">\n          <yield to="body">\n            <datatable-cell name="name">{row.name}</datatable-cell>\n            <datatable-cell name="count">{row.count}</datatable-cell>\n            <datatable-cell name="profitability">{parseInt(row.profitability).toFixed(0)}%</datatable-cell>\n            <datatable-cell name="profit">{parseInt(row.profit).toFixed(2)}</datatable-cell>\n          </yield>\n        </catalog-static>\n      </div>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.loader = false;
self.value = {};
self.productAll = [];

self.tab = 'funnel';
self.tabLoader = 'funnel';
self.tabs = [{ title: 'Воронка', name: 'funnel' }, { title: 'Статистика', name: 'statisticsOrders' }, { title: 'Продукты', name: 'products' }];

self.productsCols = [{ name: 'name', value: 'Наименование товара/услуги' }, { name: 'count', value: 'Кол-во' }, { name: 'profitability', value: 'Рентабельность' }, { name: 'profit', value: 'Доход' }];

self.tabClick = function (e) {
    if (e && e.item && e.item.name) {
        if (self.tab === e.item.name) return;
        self.tab = self.tabLoader = e.item.name;
    }

    var data = {
        startDate: self.tags.startDate.root.value ? moment(self.tags.startDate.root.value, 'DD.MM.YYYY').format('YYYY-MM-DD') : '',
        endDate: self.tags.endDate.root.value ? moment(self.tags.endDate.root.value, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
    };

    API.request({
        object: 'Analytics',
        method: 'Info',
        data: (0, _extends3.default)({}, data, {
            data: self.tab
        }),
        success: function success(response) {
            self.value = (0, _extends3.default)({}, self.value, response);
            self.productAll = self.value.products;
            console.log(self.value);
            self.tabLoader = '';
            self.update();
        }
    });
};

self.find = function (e) {
    console.log(self.productAll);
    self.value.products = [];
    var find = $('#productSearch').val();
    if (find) {
        self.productAll.forEach(function (item) {
            console.log(item);
            if (item.name.toLowerCase().indexOf(find.toLowerCase()) !== -1) {
                self.value.products.push(item);
            }
        });
    } else self.value.products = self.productAll;
};

self.createChartFunnelData = function (data) {
    if (!(data instanceof Array)) return;

    var result = {
        labels: [],
        datasets: [{
            data: [],
            backgroundColor: [],
            borderWidth: 1
        }]
    };

    data.forEach(function (value, index, array) {
        result.labels.push(value.Title);
        result.datasets[0].data.push(value.Value);
        result.datasets[0].backgroundColor.push(value.Color);
    });

    return result;
};

self.createChartStatisticsData = function (data) {
    var result = {
        labels: [],
        datasets: [{
            label: 'Статистика',
            data: [],
            backgroundColor: 'rgba(34, 139, 34, 0.3)',
            borderColor: 'rgba(34, 139, 34, 1)',
            borderWidth: 1
        }]
    };

    data.forEach(function (value, index, array) {
        var dateOrder = moment(value.dateOrder, 'YYYY-MM-DD').format('DD.MM.YYYY');
        result.labels.push(dateOrder);
        result.datasets[0].data.push(value.sum);
    });

    return result;
};

self.chartFunnelOptions = {};

self.reload = function () {
    var data = {
        startDate: self.tags.startDate.root.value ? moment(self.tags.startDate.root.value, 'DD.MM.YYYY').format('YYYY-MM-DD') : '',
        endDate: self.tags.endDate.root.value ? moment(self.tags.endDate.root.value, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
    };

    self.loader = true;
    self.update();

    if (self.root.parentNode) {
        API.request({
            object: 'Analytics',
            method: 'Info',
            data: data,
            success: function success(response) {
                self.value = (0, _extends3.default)({}, self.value, response);
                self.update();
            },
            complete: function complete() {
                self.loader = false;
                self.update();
            }
        });
    }

    self.tabClick();
};

self.one('updated', function () {
    self.tags.startDate.root.value = moment().startOf('month').format('DD.MM.YYYY');
    self.tags.endDate.root.value = moment().format('DD.MM.YYYY');
    self.reload();
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/analytics/analytics.tag